import { SideLetterPending } from 'pages/SideLetterPending/SideLetterPending';

export default SideLetterPending;
